export default class Service {
  id: string
  name: string
  constructor (id: string, displayName: string) {
    this.id = id
    this.name = displayName
  }
}
